export default {"src":"/frontend-static/_next/static/media/ic_thumbs-up.de769e41.svg","height":27,"width":26,"blurWidth":0,"blurHeight":0};